import React, { useEffect, useState, useContext } from "react";

import { useParams } from "react-router-dom";
import axios from "axios";

import { Loading, Alert } from ".";

const EmailConfirm = ({ children }) => {
  const [status, setStatus] = useState("submitting");
  const [called, setCalled] = useState(false);

  let { code, quote } = useParams();

  useEffect(() => {
    if (!code || called) {
      return;
    }

    async function fetchData() {
      setCalled(true);
      try {
        await axios.put(`/api/quotes/${quote}/verify-quote/${code}`);
        setStatus("success");
      } catch (error) {
        setStatus("error");
      }
    }

    fetchData();
  }, [code]);

  if (status === "submitting") {
    return <Loading type="loading" text="Verifying..." />;
  }

  if (status === "error") {
    return (
      <Alert
        message="YOUR OFFER HAS EXPIRED!"
        description="Kindly reach out to the team at sales@retail-circle.com to be quoted again."
      />
    );
  }

  if (status === "success") {
    return <>{children}</>;
  }
};

export default EmailConfirm;
